const Arbitrum = () => (
  <svg fill='none' viewBox='0 0 25 25'>
    <circle cx='12.688' cy='12.956' r='12' fill='#fff' />
    <path
      fill='#2D374B'
      d='m14.717 12.204 1.322-2.243 3.563 5.549.001 1.065-.012-7.329a.551.551 0 0 0-.255-.44l-6.414-3.689a.565.565 0 0 0-.548.036l-.022.014-6.227 3.608-.024.01a.55.55 0 0 0-.322.469l.01 5.972 3.319-5.144c.418-.682 1.328-.901 2.173-.89l.992.026-5.844 9.372.689.397 5.914-9.76 2.614-.009-5.9 10.006 2.46 1.414.293.17c.127.05.268.052.396.007l6.505-3.77-1.244.721-3.44-5.562Zm.504 7.263-2.483-3.897L14.254 13l3.26 5.14-2.293 1.328Z'
    />
    <path
      fill='#28A0F0'
      d='m12.738 15.57 2.483 3.897 2.294-1.33L14.255 13l-1.517 2.571Zm6.866 1.005-.002-1.065-3.563-5.55-1.322 2.243 3.44 5.563 1.244-.72a.552.552 0 0 0 .203-.402v-.07Z'
    />
    <path
      fill='#fff'
      d='m4.673 17.58 1.756 1.011 5.844-9.372-.992-.026c-.845-.012-1.755.208-2.173.89L5.79 15.227l-1.116 1.715v.638Zm10.973-8.361-2.614.01-5.914 9.759 2.067 1.19.562-.954 5.9-10.005Z'
    />
    <path
      fill='#96BEDC'
      d='M20.705 9.205a1.665 1.665 0 0 0-.782-1.338L13.425 4.13a1.69 1.69 0 0 0-1.491 0c-.055.027-6.32 3.66-6.32 3.66a1.669 1.669 0 0 0-.942 1.412v7.74l1.116-1.716-.008-5.971a.555.555 0 0 1 .23-.415c.029-.021 6.402-3.71 6.422-3.72a.565.565 0 0 1 .49-.002l6.415 3.69a.552.552 0 0 1 .255.439v7.398a.537.537 0 0 1-.192.401l-1.244.72-.642.373-2.293 1.329-2.326 1.348a.564.564 0 0 1-.396-.008l-2.752-1.583-.562.954 2.473 1.424.215.12c.092.052.155.088.177.098a1.654 1.654 0 0 0 1.262.021l6.756-3.912a1.651 1.651 0 0 0 .637-1.244v-7.48Z'
    />
  </svg>
)

export { Arbitrum }
